import React from 'react';
import { connect } from 'react-redux';
import { ACTIONS } from '../modules/constants';

const ResetButton = (props) => {
  return (
    <span className="ResetBtn" onClick={() => {
      props.dispatch({ type: ACTIONS.RESET })
    }}
    ><i className="fa fa-refresh" aria-hidden="true" /></span>
  );
};

export default connect()(ResetButton);



// WEBPACK FOOTER //
// ./src/containers/ResetButton.js